const timeFormats = {
  AM_PM_TIME: 'hh:mm a',
  MONTH_DAY_YEAR: 'MMM DD yyyy',
  SLASHED_MONTH_DAY_YEAR: 'MM/dd/yyyy',
  DATE_OF_BIRTHDAY: 'MM/DD/yyyy',
  MINUS_MONTH_DAY_YEAR: 'MM-DD-yyyy',
  MINUS_MONTH_DAY_YEAR_TIME: 'MM-DD-yyyy h:mm a',
  APPOINTMENT_CARD_DATE: 'dddd, MMMM DD, YYYY',
  MESSAGE_GROUP_DATE: 'MMM DD, YYYY',
  MESSAGE_DATE: 'hh:mm A',
  NOTE_TIME: 'MM/DD/YY h:mm a',
  DATE_TERE: 'YYYY-MM-DD',
  DATEPICKER_DATE: 'MMMM DD, YYYY',
  DATE_PIPE: 'MMM DD, YYYY | h:mm a',
  TIME_COMA_DATE: 'h:mm a, MMM DD, YYYY',
  DD: 'DD',
  ddd: 'ddd',
  WEEK_DAY_DATE_HOURS: 'dddd, MMMM D, YYYY hh:mm a',
};

export default timeFormats;
